/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const MasterQueryKeys = {
  all: ['user'] as const,
  lists: () => [...MasterQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...MasterQueryKeys.lists(), { filters }] as const,
  details: () => [...MasterQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...MasterQueryKeys.details(), id] as const,
};
